import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import {
    Container,
    Flex,
    Grid,
    Loader,
    Tabs,
    Text,
    Title,
    useMantineColorScheme,
} from "@mantine/core";

import {
    OverviewTab,
    SEOTab,
} from "../../components/TenantDetail";
import { useAuthContext } from "../../hooks/auth";
import { useClientTenant } from "../../hooks/clients";

const defaultTab = "overview";

export interface TenantDetailPageProps {}
export const TenantDetailPage = ({}: TenantDetailPageProps) => {
    const { t } = useTranslation(["common"]);
    const params = useParams();
    const navigate = useNavigate();

    const { colorScheme } = useMantineColorScheme();

    const tab = params?.tab || defaultTab;

    const { client } = useAuthContext();

    const {
        clientTenant,
        isLoadingClientTenant,
        reloadClientTenant,
    } = useClientTenant(params?.tenantId);

    return (
        <>
            <Flex
                align="center"
                justify="space-between"
                mb="lg"
                pb="md"
                rowGap={8}
                wrap="wrap"
                style={{
                    borderBottom: "1px solid #E0E0E0",
                }}
            >
                <Flex gap={16} align="center">
                    <Title order={3} style={{ fontWeight: 600 }}>
                        {isLoadingClientTenant ? <Loader/> : clientTenant?.name}
                    </Title>
                </Flex>
            </Flex>
            <Tabs
                styles={{
                    tab: {
                        paddingInline: 12,
                        paddingBlock: 8,
                    },
                }}
                variant="pills"
                orientation="vertical"
                color={colorScheme === "dark" ? "orange" : "gray"}
                keepMounted={false}
                value={tab}
                onTabChange={(tab) =>
                    navigate(`/tenant/${params?.tenantId}${tab === defaultTab ? "" : `/${tab}`}`)}
            >
                <Grid w="100%" gutter={0}>
                    <Grid.Col md="content" pr={20} pb={20}>
                        <Tabs.List mb={24}>
                            <Tabs.Tab value="overview">
                                <Text size={14} weight={600}>
                                    {t("tenant_tab_overview")}
                                </Text>
                            </Tabs.Tab>
                            <Tabs.Tab value="seo">
                                <Text size={14} weight={600}>
                                    {t("tenant_tab_seo")}
                                </Text>
                            </Tabs.Tab>
                        </Tabs.List>
                    </Grid.Col>
                    <Grid.Col md="auto">
                        <Container size="sm" p={0}>
                            <Tabs.Panel value="overview">
                                <OverviewTab
                                    tenant={clientTenant}
                                    onTenantUpdate={reloadClientTenant}
                                />
                            </Tabs.Panel>
                            <Tabs.Panel value="seo">
                                <SEOTab
                                    tenant={clientTenant}
                                    onTenantUpdate={reloadClientTenant}
                                />
                            </Tabs.Panel>
                            {/* <Tabs.Panel value="billing">
                                <ClientBilling
                                    client={client}
                                    isLoading={!selectedClient?.id || isLoadingClient}
                                    onClientUpdate={reloadClient}
                                />
                            </Tabs.Panel>
                            {[
                                ClientUserRole.owner,
                                ClientUserRole.admin,
                            ].indexOf(selectedClient?.role) >= 0 && (
                                <Tabs.Panel value="users">
                                    <ClientUsers client={client} />
                                </Tabs.Panel>
                            )} */}
                        </Container>
                    </Grid.Col>
                </Grid>
            </Tabs>
        </>
    );
};
